export const ADD_LINKS = 'ADD_LINKS'
export const ADD_BATCH = 'ADD_BATCH'
export const SET_LOADING_STATUS = 'SET_LOADING_STATUS'
export const SET_AFTER = 'SET_AFTER'
export const SET_FETCH_COUNT = 'SET_FETCH_COUNT'
export const LOAD_NUMBERED_PAGE = 'LOAD_NUMBERED_PAGE'
export const REFRESH = 'REFRESH'
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS'
export const SET_SUBREDDIT_FILTER = 'SET_SUBREDDIT_FILTER'
export const SET_SORTING_METHOD = 'SET_SORTING_METHOD'
export const UNSAVE_POST = 'UNSAVE_POST'
export const RESET_PAGE_NUMBER = 'RESET_PAGENUMBER'
export const CLEAR_STATE = 'CLEAR_STATE'
export const SET_NSFW_FILTER = 'SET_NSFW_FILTER'
export const RESET_NSFW_FILTER = 'RESET_NSFW_FILTER'

// User Action Types
export const SET_TOKENS = 'SET_TOKENS'
export const SET_USER_DETAILS = 'SET_USER_DETAILS'
export const UPDATE_TOKEN = 'UPDATE_TOKEN'
